"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Caption1Strong", {
    enumerable: true,
    get: function() {
        return Caption1Strong;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _createPreset = require("../createPreset");
const _useCaption1StrongStylesstyles = require("./useCaption1StrongStyles.styles");
const Caption1Strong = (0, _createPreset.createPreset)({
    useStyles: _useCaption1StrongStylesstyles.useCaption1StrongStyles,
    className: _useCaption1StrongStylesstyles.caption1StrongClassNames.root,
    displayName: 'Caption1Strong'
});
